import { useMemo, useState } from "react";
import "./AdminProdutosDestaque.css";

function AdminProdutosDestaque({
    produtosDestaque,
    localizacao,
    onAtualizar,
    atualizarProdutosDestaque
}) {
    const [filtro, setFiltro] =
        useState("");

    const disponiveis = useMemo(() => {
        return produtosDestaque.filter(
            (item) =>
                Number(item.site) === 0
        );
    }, [produtosDestaque]);

    const filtrados = useMemo(() => {
        if (!filtro) return [];

        return disponiveis.filter(
            (item) =>
                item.descricao
                    ?.toLowerCase()
                    .includes(
                        filtro.toLowerCase()
                    ) ||
                String(
                    item.produto_id
                ).includes(filtro)
        );
    }, [filtro, disponiveis]);


    const selecionados = useMemo(() => {
        return produtosDestaque.filter(
            (item) =>
                Number(item.site) === 1 &&
                Number(item.site_posi) ===
                Number(localizacao)
        );
    }, [
        produtosDestaque,
        localizacao
    ]);

    async function adicionar(
        produto
    ) {
        try {
            await fetch(
                `https://app.eliandroalimentos.com.br/api/produtos_destaque/editardesconto/${produto.id}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type":
                            "application/json",
                    },
                    body: JSON.stringify({
                        site: 1,
                        site_posi: Number(
                            localizacao
                        ),
                    }),
                }
            );

            setFiltro("");

            if (onAtualizar) {
                await onAtualizar();
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function remover(
        produto
    ) {
        try {
            await fetch(
                `https://app.eliandroalimentos.com.br/api/produtos_destaque/editardesconto/${produto.id}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type":
                            "application/json",
                    },
                    body: JSON.stringify({
                        site: 0,
                        site_posi: 0,
                    }),
                }
            );

            if (onAtualizar) {
                await onAtualizar();
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div className="admin-categorias">
            <h2>
                Produtos Destaque
            </h2>


            <div className="busca-wrapper">
                <input
                    type="text"
                    placeholder="Descrição ou código..."
                    value={filtro}
                    onChange={(e) =>
                        setFiltro(
                            e.target.value
                        )
                    }
                />

                {filtrados.length > 0 && (
                    <div className="resultado-busca">
                        {filtrados
                            .slice(0, 15)
                            .map((item) => {
                                let classe = "";
                                let diferencaDias = null;

                                if (item.data_validade) {
                                    const hoje = new Date();
                                    hoje.setHours(0, 0, 0, 0);

                                    const validade = new Date(item.data_validade);
                                    validade.setHours(0, 0, 0, 0);

                                    if (!isNaN(validade.getTime())) {
                                        diferencaDias = Math.floor(
                                            (validade.getTime() - hoje.getTime()) /
                                            (1000 * 60 * 60 * 24)
                                        );

                                        if (diferencaDias < 0) {
                                            classe = "categoria-vencida";
                                        } else if (diferencaDias <= 2) {
                                            classe = "categoria-proxima-vencer";
                                        }
                                    }
                                }


                                return (
                                    <div
                                        key={item.id}
                                        className={`resultado-item ${classe}`}
                                        onClick={() => adicionar(item)}
                                    >
                                        {" "}
                                        {item.produto_id}
                                        {" - "}
                                        {item.descricao}
                                    </div>
                                );
                            })}
                    </div>
                )}

            </div>

            <h3>
                Produtos da posição{" "}
                {localizacao}
            </h3>

            <div className="lista-categorias-menu">
                {selecionados.map((item) => {
                    const hoje = new Date();
                    hoje.setHours(0, 0, 0, 0);

                    const validade = new Date(item.data_validade);
                    validade.setHours(0, 0, 0, 0);

                    const diferencaDias = Math.floor(
                        (validade - hoje) / (1000 * 60 * 60 * 24)
                    );

                    let classe = "";

                    if (diferencaDias < 0) {
                        classe = "categoria-vencida";
                    } else if (diferencaDias <= 2) {
                        classe = "categoria-proxima-vencer";
                    }

                    return (
                        <div
                            key={item.id}
                            className={`categoria-menu-item ${classe}`}
                        >
                            <span>
                                {item.produto_id}
                                {" - "}
                                {item.descricao}
                            </span>

                            <button
                                onClick={() => remover(item)}
                            >
                                X
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default AdminProdutosDestaque;